import { render, staticRenderFns } from "./recommend-cate-dialog.vue?vue&type=template&id=7c8a72be"
import script from "./recommend-cate-dialog.vue?vue&type=script&lang=js"
export * from "./recommend-cate-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports